/**
 * Created by evgeny on 19.08.2024
 */
const Untouchable = function (unit) {
    UnitComponent.call(this, unit);
};

Untouchable.prototype = Object.create(UnitComponent.prototype);
Untouchable.prototype.constructor = Untouchable;